export default function reducer(
  state = {
    list: [],
    search: [],
    detail: {},
  },
  action
) {
  switch (action.type) {
    case 'FETCH_AREAS': {
      return {
        ...state,
        fetching: true,
      };
    }
    case 'FETCH_AREAS_FULFILLED': {
      const { collection } = action.payload;
      // localStorage.setItem("areas", JSON.stringify(collection));

      return {
        ...state,
        list: collection,
      };
    }
    case 'FETCH_AREAS_REJECTED': {
      return {
        ...state,
        error: action.payload ? action.payload.error : `[${action.type}] No response`,
      };
    }

    case 'FETCH_AREA_FULFILLED': {
      const newDetail = { ...state.detail };
      newDetail[action.payload.id] = action.payload;
      return {
        ...state,
        detail: newDetail,
      };
    }

    default:
      return state;
  }
}
